
import { Inertia } from "@inertiajs/inertia";
import { computed, defineComponent } from "vue";
import ButtonGroup from "../Buttons/ButtonGroup.vue";
import Card from "../General/Card.vue";

export default defineComponent({
  props: {
    selected: String,
  },
  setup(props) {
    const options = [
      {
        id: "orders",
        title: "Ordre",
        url: route("orders.index", { type: "orders" }),
      },
      {
        id: "weborders",
        title: "Webordre",
        url: route("orders.index", { type: "weborders" }),
      },
    ];

    const navigate = (item: any) => {
      Inertia.get(item.url);
    };

    return {
      options,
      navigate,
    };
  },
  components: { ButtonGroup, Card },
});
